module.exports = __webpack_public_path__ + "static/media/snx.3726c7df.svg";